import React from "react";
import {
    Button,
    Grid,
    FormControl,
    InputLabel,
    // makeStyles,
    Select,
    MenuItem,
    Typography,
    Box,
    CircularProgress
} from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { format, parse } from "date-fns";

import SimpleInput from "../../Frequents/SimpleInput";
import SelectBoolean from "../../Frequents/SelectBoolean";
// const useStyles = makeStyles(theme => ({}))

export const PersonalInFormationForm = props => {
    // const classes = useStyles();
    const {
        classes,
        clientData,
        changeValue,
        get4lastDigitCPR,
        errors,
        handleTabChange,
        isPatient,
        validateAndNextStep,
        ids,
        loading
    } = props;

    const selectedDate = clientData.CPR6Digit ? parse(clientData.CPR6Digit, "yyMMdd", new Date()) : null;

    const handleDateChange = date => {
        if (date) {
            const formattedDate = format(date, "yyMMdd"); // Convert to YYMMDD
            changeValue("CPR6Digit")(formattedDate);
        }
    };
    return (
        <Box className={classes.main}>
            <Box className={classes.root}>
                <Box>
                    <Typography className={classes.heading}>Personlige oplysninger</Typography>
                </Box>

                <Grid container component="main" spacing={3}>
                    <Grid item xs={12} sm={6} md={4} lg={3} style={{ width: "100%", padding: "5px 10px !important" }}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                style={{ width: "100%" }}
                                disableFuture
                                autoOk
                                variant="inline"
                                format="yyMMdd"
                                margin="normal"
                                label="Fødselsdag (YYMMDD)"
                                value={selectedDate}
                                onChange={handleDateChange}
                                KeyboardButtonProps={{
                                    "aria-label": "change date"
                                }}
                                error={!!errors.CPR6Digit}
                                helperText={errors.CPR6Digit}
                            />
                        </MuiPickersUtilsProvider>
                        {/* <SimpleInput
                            style={{ flex: 1 }}
                            id="CPR6Digit"
                            name="CPR6Digit"
                            type="cprLast6Digit"
                            text="Fødselsdag"
                            required={true}
                            prop={clientData.CPR6Digit}
                            changeValue={changeValue("CPR6Digit")}
                            maxLength={4}
                            showError={true}
                        /> */}
                        {/* {errors.CPR6Digit && (
                            <p
                                className={classes.errMsg}
                                // style={{
                                //     color: "red",
                                //     margin: "0",
                                //     fontFamily: "Roboto",
                                //     lineHeight: "24px",
                                //     fontSize: "12px"
                                // }}
                            >
                                {errors.CPR6Digit}
                            </p>
                        )} */}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={8}
                        lg={6}
                        style={{ width: "100%", position: "relative", padding: "5px 10px !important" }}
                        className={classes.codeField}>
                        <SimpleInput
                            style={{ flex: 1 }}
                            id="CPRLast4Digit"
                            name="CPRLast4Digit"
                            type="cprLast4Digit"
                            text="De sidste 4 cifre i dit CPR nr"
                            required={true}
                            prop={clientData.CPRLast4Digit}
                            changeValue={changeValue("CPRLast4Digit")}
                            maxLength={4}
                            showError={true}
                        />
                        {errors.CPRLast4Digit && <p className={classes.errorMessage}>{errors.CPRLast4Digit}</p>}
                        <Button className={classes.button} variant="contained" onClick={get4lastDigitCPR}>
                            Generer unik kode
                        </Button>
                    </Grid>
                    {[
                        ["nameFirst", "Fornavn", "text", true],
                        ["nameLast", "Efternavn", "text", true],
                        ["address", "Adresse", "text", true],
                        ["post", "Postnummer", "number", true],
                        ["town", "By", "text", true]
                    ].map(field => {
                        return (
                            <Grid
                                key={field[0]}
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={3}
                                style={{ width: "100%", padding: "5px 10px !important" }}>
                                <SimpleInput
                                    name={"clientData" + field[0]}
                                    text={field[1]}
                                    key={"clientData" + field[0]}
                                    type={field[2]}
                                    required={field[3]}
                                    prop={clientData[field[0]]}
                                    changeValue={changeValue(field[0])}
                                    showError={true}
                                />
                                {errors[field[0]] && <p className={classes.errMsg}>{errors[field[0]]}</p>}
                            </Grid>
                        );
                    })}

                    {[
                        ["phonePrivate", "Telefon privat"],
                        ["phoneWork", "Telefon arbejde"],
                        ["phoneRelative", "Telefon pårørende"]
                    ].map(([fieldKey, fieldLabel]) => {
                        return (
                            <Grid
                                key={fieldKey}
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={3}
                                style={{ width: "100%", padding: "5px 10px !important" }}>
                                <SimpleInput
                                    name={"clientData" + fieldKey}
                                    text={fieldLabel}
                                    type="phone"
                                    key={"clientData" + fieldKey}
                                    prop={
                                        clientData[fieldKey]?.startsWith("+")
                                            ? clientData[fieldKey].substring(3)
                                            : clientData[fieldKey]
                                    }
                                    changeValue={value => changeValue(fieldKey)(value)}
                                />
                                {errors[fieldKey] && <p className={classes.errMsg}>{errors[fieldKey]}</p>}
                            </Grid>
                        );
                    })}

                    <Grid item xs={12} sm={6} md={4} lg={3} style={{ width: "100%", padding: "5px 10px !important" }}>
                        <FormControl style={{ width: "100%", marginTop: "10px" }}>
                            <InputLabel id="clientDataCivilStatus">Civilstatus</InputLabel>
                            <Select
                                labelId="clientDataCivilStatus"
                                id="clientDataCivilStatus"
                                name="clientDataCivilStatus"
                                IconComponent={() => null}
                                onChange={event => changeValue("civilStatus")(event.target.value)}
                                value={clientData.civilStatus || ""}>
                                <MenuItem value={null} disabled>
                                    Vælg...
                                </MenuItem>
                                <MenuItem value={"Single"}>Single</MenuItem>
                                <MenuItem value={"Gift"}>Gift</MenuItem>
                                <MenuItem value={"Samboende"}>Samboende</MenuItem>
                                <MenuItem value={"Enke"}>Enke</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3} style={{ width: "100%", padding: "5px 10px !important" }}>
                        <SelectBoolean
                            key="clientDataSex"
                            name="clientDataSex"
                            text="Køn"
                            prop={clientData.sex || ""}
                            choice1="Mand"
                            choice2="Kvinde"
                            value1={1}
                            value2={2}
                            changeValue={changeValue("sex")}
                        />
                    </Grid>
                    {[
                        ["education", "Uddannelse", "text"],
                        ["children", "Antal børn", "number"],
                        ["doctor", "Egen læge", "text"],
                        ["otherTreater", "Anden behandler", "text"]
                    ].map(field => {
                        return (
                            <Grid
                                key={field[0]}
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={3}
                                style={{ width: "100%", padding: "5px 10px !important" }}>
                                <SimpleInput
                                    name={"clientData" + field[0]}
                                    key={"clientData" + field[0]}
                                    text={field[1]}
                                    type={field[2]}
                                    prop={clientData[field[0]]}
                                    changeValue={changeValue(field[0])}
                                />
                            </Grid>
                        );
                    })}
                    <Grid item xs={12} sm={6} md={4} lg={3} style={{ width: "100%", padding: "5px 10px !important" }}>
                        <SimpleInput
                            name="email"
                            key="email"
                            type="mail"
                            text="E-mail"
                            prop={clientData?.email}
                            changeValue={changeValue("email")}
                        />
                        {errors.email && <p className={classes.errorMessage}>{errors.email}</p>}
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            width: "100%",
                            paddingTop: "14px",
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column-reverse",
                            textAlign: "center"
                        }}>
                        <Button
                            className={classes.submit}
                            size="small"
                            onClick={() => {
                                if (isPatient === true) {
                                    validateAndNextStep();
                                } else {
                                    handleTabChange("", 1);
                                }
                            }}
                            disabled={loading}>
                            {ids?.length === 0 ? (
                                <> indsende {loading && <CircularProgress size={24} color="inherit" />}</>
                            ) : (
                                "næste"
                            )}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};
